import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { CrossNameSpaceOrganziation } from "@src/types/namespace-configuration";

export interface GetOrganizationByIdResult {
  success: boolean;
  data?: CrossNameSpaceOrganziation;
  error?: string;
}

export const getOrganizationByIdUseCase = async (
  organizationId: string,
): Promise<GetOrganizationByIdResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const organization = await apiUseCases.getOrganizationById(
      namespace,
      organizationId,
    );

    return {
      success: true,
      data: organization,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to fetch organization").message,
    };
  }
};
